/* eslint-disable react/no-unknown-property */
/* eslint-disable max-len */
import React from 'react';

/**
 * NextArrowIcon - Auto-generated from icon.js
 */
export const NextArrowIcon = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
		<g filter="url(#filter0_d_518_9)">
			<path d="M15.0013 13.011C15.0017 13.2442 14.9203 13.4703 14.7713 13.6499L9.77125 19.6394C9.60151 19.8432 9.3576 19.9714 9.09318 19.9958C8.82875 20.0201 8.56547 19.9386 8.36125 19.7692C8.15704 19.5997 8.02861 19.3562 8.00423 19.0923C7.97985 18.8283 8.06151 18.5655 8.23125 18.3616L12.7113 13.011L8.39125 7.66034C8.30819 7.55824 8.24615 7.44074 8.20872 7.31463C8.17129 7.18851 8.1592 7.05625 8.17314 6.92545C8.18708 6.79465 8.22677 6.66789 8.28995 6.55245C8.35312 6.43702 8.43853 6.33519 8.54125 6.25281C8.64407 6.16139 8.7647 6.09215 8.89557 6.04943C9.02645 6.00671 9.16475 5.99144 9.30181 6.00456C9.43887 6.01768 9.57175 6.05891 9.6921 6.12568C9.81246 6.19244 9.91771 6.28331 10.0013 6.39256L14.8313 12.3821C14.9568 12.5668 15.0166 12.7883 15.0013 13.011Z" fill="white" />
		</g>
		<defs>
			<filter id="filter0_d_518_9" x="0" y="-2" width="23.0036" height="30" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
				<feFlood floodOpacity="0" result="BackgroundImageFix" />
				<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
				<feOffset />
				<feGaussianBlur stdDeviation="4" />
				<feComposite in2="hardAlpha" operator="out" />
				<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" />
				<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_518_9" />
				<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_518_9" result="shape" />
			</filter>
		</defs>
	</svg>
);

export default NextArrowIcon;
